/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CaseManagementUserType } from '../enums/case-management-user-type.enum';

export class CaseManagementUserDto {
  public userType: CaseManagementUserType;
  public name: string = undefined;
  public email: string = undefined;
  public initials: string = undefined;
  public isEcus: boolean;
  public isClient: boolean;
  public isSystem: boolean;

  //<custom-body>
  constructor(source: CaseManagementUserDto) {
    Object.assign(this, source);
  }
  //</custom-body>
}
